import React, { useEffect } from "react";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/client";
import { DisableSubscriptionMutation } from "arena/mutations";
import ErrorScreen from "core/components/ErrorScreen";
import { useParams } from "react-router-dom";

const Root = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
});

export default function DisableSubscription() {
  const { token } = useParams();
  const { t } = useTranslation("site");

  const [disableSubscription, { error, data }] = useMutation(
    DisableSubscriptionMutation,
    {
      variables: { token },
    }
  );

  useEffect(disableSubscription, []);

  if (error) {
    return (
      <Root>
        <ErrorScreen error={error} />
      </Root>
    );
  }

  if (data) {
    return (
      <Root>
        <Typography variant="h6">{t("disableSubscription.success")}</Typography>
      </Root>
    );
  }

  return (
    <Root>
      <CircularProgress />
    </Root>
  );
}
